import { withCompInfo } from '@wix/editor-elements-integrations'
import type { PopupPageCSSVars, PopupPageDefinition } from './PopupPage'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { getBackgroundMedia } from '../PageBackground/PageBackground.mapper'

export const css = withCompInfo<PopupPageCSSVars, PopupPageDefinition>()(
	[
		'compData',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compData,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = getBackgroundMedia(compData, isMobileView)
		const fillLayersCss = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compId,
			compDesign,
			compProps,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})
		return {
			...fillLayersCss,
			width: 'auto',
		}
	}
)
